import React, { useRef } from 'react';
import { Button } from '../ui/button';
import { IoMdClose } from 'react-icons/io';
import Notebook from '../notebook/Notebook';

const BottomSheet = (props: any) => {
  const {
    children,
    open,
    onCancel,
    onDelete,
    onSave,
    title = 'Bottom Sheet',
    subTitle,
    saveLabel = 'Save & Close',
    cancelLabel = 'Cancel',
    deleteGoods = false,
    deleteLabel = 'Delete',
    disabled = false,
    client = null,
    room = null,
    supplier = null,
    existingId,
    headerActions = false,
    loading,
    handleDuplicateGoods,
    accountUser,
    row,
    notebookRef,
    orderItemType,
    roomName,
    newOrder,
    showIconTitle,
    canAccessTeamSettings,
    window_location_id = '',
    statusBadge,
    hideSubTitle = false,
    hideDuplicate = false,
    headerLocked = false,
    footerActions = null,
    headerExtra = null,
    hideCancel = false,
  } = props;

  const bottomSheetRef = useRef<any>(null);

  const handleSubTitleClassName = (item: string) => {
    let lowered_joined_name = item?.toLowerCase()?.replace(' ', '_');

    switch (lowered_joined_name) {
      case 'new_item':
        return 'new';
      case 'edit_item':
        return 'edit';
      case 'copy_item':
        return 'duplicate';
      default:
        return 'default';
    }
  };

  return (
    <div ref={bottomSheetRef} className={`bottom_sheet ${open ? 'active' : 'notActive'}`}>
      <div
        className={`bottom_sheet_header_wrapper ${
          headerLocked ? 'bg-primary/5 border-b-primary/20' : ''
        }`}
      >
        <div className="bottom_sheet_header">
          <div className="bottom_sheet_header_title_row">
            <div className="bottom_sheet_header_title">
              <span className="title">{orderItemType || title}</span>
              <span className="client">{supplier && ` - ${supplier.displayName}`}</span>
              <span className="client">{client && ` - ${client.displayName}`}</span>
              <span className="room">{room && ` / ${room.name}`}</span>
              <span className="room">{window_location_id && ` / ${window_location_id}`}</span>
            </div>
            {statusBadge && <div className="bottom_sheet_header_status">{statusBadge}</div>}
          </div>
          {subTitle && !hideSubTitle && (
            <span className={`bottom_sheet_header_subtitle ${handleSubTitleClassName(subTitle)}`}>
              {subTitle}
            </span>
          )}
          {headerExtra && <div className="bottom_sheet_header_extra">{headerExtra}</div>}
        </div>

        <div className="flex shrink-0 items-start gap-2">
          {headerActions && (
            <div className="flex items-center justify-end gap-2">
              <Notebook
                row={row}
                defaultTab="items"
                notebookTabs={['projects', 'items']}
                user={accountUser}
                table={'items'}
                orderItemType={orderItemType}
                orderOpen={open}
                ref={notebookRef}
                roomName={roomName}
                newOrder={newOrder}
                client={client}
                showIconTitle={showIconTitle}
                canAccessTeamSettings={canAccessTeamSettings}
                closeOnOutsideClick={false}
              />

              {existingId && !hideDuplicate && (
                <Button
                  className="m-0"
                  disabled={loading || disabled}
                  onClick={() => handleDuplicateGoods()}
                  variant={'create-outline'}
                >
                  {loading ? (
                    <div>
                      <span className="mr-[10px]">&#10003;</span> <span>Duplicated</span>
                    </div>
                  ) : (
                    <div>
                      <span>Duplicate</span>
                    </div>
                  )}
                </Button>
              )}

            </div>
          )}

          <div className="flex h-[40px] items-center">
            <button
              disabled={disabled}
              className="x_button"
              type="button"
              onClick={() => onCancel()}
            >
              <IoMdClose fontSize={16} />
            </button>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="p-4 md:p-6 space-y-4 md:space-y-6">{children}</div>
      </div>

      <div style={{ borderColor: '#e2e8f0' }} className="bg-background border-t p-4 z-20">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-4">
            {deleteGoods && (
              <Button
                disabled={disabled}
                variant={'delete-outline'}
                onClick={() => {
                  if (onDelete) onDelete();
                }}
                type="button"
              >
                {deleteLabel}
              </Button>
            )}
          </div>

          <div className="flex gap-2 items-center">
            {!hideCancel && (
              <div className="bottom_sheet_button_container">
                <Button
                  // disabled={disabled}
                  variant={'cancel'}
                  onClick={() => onCancel()}
                  type="button"
                >
                  {cancelLabel}
                </Button>
              </div>
            )}

            <div className="bottom_sheet_button_container">
              {footerActions || (
                <Button
                  disabled={disabled}
                  variant={'default'}
                  onClick={() => onSave()}
                  type="button"
                >
                  {saveLabel}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
